// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 15:21:15
import { ListCrisisQuittance_abstract } from './../../abstract/SagaSchema/ListObjects/ListCrisisQuittance_abstract';
export class ListCrisisQuittance extends ListCrisisQuittance_abstract {}
